import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { CareTeamActionButtonFrom } from '../../../../shared/CareTeamForm';
import useCareTeamMember from '../../../../../hooks/api/useCareTeamMember';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

export type AddCareTeamMemberOwnProps = {};

export type AddCareTeamMemberNavigatorProps = {
    route: RouteProp<ProfilesTabParamList, 'edit-care-team-member'>;
};

export type AddCareTeamMemberProps = AddCareTeamMemberOwnProps & AddCareTeamMemberNavigatorProps;

const AddCareTeamMember: React.FC<AddCareTeamMemberProps> = ({ route }) => {
    const navigator = useProfilesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { updateCareTeamMember, isUpdatingCareTeamMember, careTeamMember, isLoadingCareTeamMember } =
        useCareTeamMember({
            medicalProfileId: route.params.profileId,
            careTeamMemberId: route.params.careTeamMemberId,
            onUpdateCareTeamMemberSuccess: () => {
                navigator.navigate('care-team', {
                    profileId: route.params.profileId,
                });
            },
        });

    return (
        <AnimateLoadedContent isLoading={isLoadingCareTeamMember || !careTeamMember || isUpdatingCareTeamMember}>
            {() => (
                <CareTeamActionButtonFrom
                    onSubmit={updateCareTeamMember}
                    isSubmitting={isUpdatingCareTeamMember}
                    source={{
                        source: 'profile',
                        medicalProfileId: route.params.profileId,
                    }}
                    careTeamMemberId={route.params.careTeamMemberId}
                    careTeamMemberDetails={careTeamMember}
                    shouldRecordAddCareTeamMember
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddCareTeamMember);
